/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from "../../../../context";

function Sidenav({ items = [], selected, onSelect }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const renderSidenavItems = items.map(({ label, description, href }, key) => {
    const itemKey = `item-${key}`;
    const isSelected = selected === href;

    return (
      <MDBox key={itemKey} component="li" pt={key === 0 ? 0 : 1} mb={1.5}>
        <MDBox
          component="a"
          href={`#${href}`}
          onClick={(e) => {
            e.preventDefault();
            onSelect && onSelect(href);
          }}
          display="block"
          sx={({
            borders: { borderRadius },
            functions: { pxToRem },
            palette,
            transitions,
          }) => ({
            textDecoration: "none",
            borderRadius: borderRadius.lg,
            padding: `${pxToRem(14)} ${pxToRem(18)}`,
            backgroundColor: isSelected
              ? palette.accent.main
              : darkMode
                ? palette.background.card
                : palette.white.main,
            color: isSelected
              ? palette.white.main
              : darkMode
                ? palette.white.main
                : palette.text.primary,
            boxShadow: isSelected
              ? "0px 6px 12px rgba(0,0,0,0.18)"
              : "0px 4px 10px rgba(0,0,0,0.08)",
            transition: transitions.create(["background-color", "box-shadow"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.shorter,
            }),
            "&:hover": {
              backgroundColor: palette.accent.focus,
            },
          })}
        >
          <MDTypography variant="button" fontWeight="bold" color="inherit">
            {label}
          </MDTypography>
          <MDTypography
            variant="caption"
            color="inherit"
            display="block"
            mt={0.5}
          >
            {description}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  });

  return (
    <MDBox
      component="ul"
      display="flex"
      flexDirection="column"
      px={2}
      m={0}
      sx={{ listStyle: "none" }}
    >
      {renderSidenavItems}
    </MDBox>
  );
}

export default Sidenav;
